export const TASK_DESTINATION = 'taskDestination';
export const TASK_ORIGIN = 'taskOrigin';
export const COMPANY_ADDRESS = 'companyAdress';
export const RECIPIENT_ADDRESS = 'recipientAddress';
export const TERMINAL = 'terminal';
